export const ApiUrl = 'https://goshortzapi.goavito.com/'
// 
export const videoUrl = 'https://goshortzapi.goavito.com'

// export const ApiUrl = 'http://localhost:4689/'

// export const videoUrl = 'http://localhost:4689'